import { render } from "./ViewAsSomeoneElse.vue?vue&type=template&id=3a5c03b8&ts=true"
import script from "./ViewAsSomeoneElse.vue?vue&type=script&lang=ts"
export * from "./ViewAsSomeoneElse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__